document.querySelector('body').classList.add('js');